<h1>Vos factures à payer</h1>

<fs-creancier-selector *ngIf="hasMultiSuppliers" [supplierList]="suppliersList" [selectedSupplierId]="activeSupplierId"
  (selectSupplier)="fournisseurChange($event)">
</fs-creancier-selector>

<fs-filters pageName="balance-outstanding" (filterCriteriaChange)="filterPieces($event)"></fs-filters>

<div id="table-cart-container" *ngIf="rowsInitialized">
  <div id="left">
    <div>
      <fs-message-card [cardClass]="paymentMsgClass" *ngIf="displayPaymentMsg">
        <div header> {{ paymentMsgHeader }} </div>
        <div body [innerHtml]="paymentMsgBody"></div>
      </fs-message-card>

      <div class="table-info">Sur le créancier sélectionné, vous êtes redevable de
        <span class="total-amount">
          {{ accountResult.Solde | number : '1.2-2' }} €
        </span>
      </div>

      <fs-cdk-table tableId="balanceOutstanding" data-testid="balance-outstanding-table" [rows]="accountResult.Pieces"
        [displayedColumns]="displayedColumns" [columns]="columns" [currentPage]="currentPage" [askedPage]="askedPage"
        [totalPages]="totalPages" [totalEntries]="totalEntries" [itemsPerPage]="itemsPerPage"
        [listSizeItemsPerPage]="listSizeItemsPerPage" (changePage)="changePage($event)"
        (callbackPagination)="fetchUnpaidPieces()" (changeSizePage)="onChangeSizePage($event)"
        (columnClicked)="onColumnClick($event)" (cellClicked)="onCellClick($event)" [isAllRowsSelected]="isAllInCart"
        [clickableRows]="true">
      </fs-cdk-table>
    </div>

    <div class="empty-infos" *ngIf="accountResult.Pieces.length === 0">
      Vous n'avez aucune facture à payer
    </div>
  </div>

  <div id="right" *apply-access-rights="Right.Cart">
    <fs-fast-picker pageName="balance-outstanding" (clickPay)="goToSelectPay()" [cartContent]="cartContent"
      [cartAmount]="cartAmount" (cartAmountValue)="cartAmount = $event" [supplierId]="activeSupplierId"
      [payDisabled]="payDisabled">
    </fs-fast-picker>
  </div>
</div>
